

export default {
    head() {
        return {
            title: this.campusInfo?.attributes?.metaTitleOffreAlt ? 
                `${this.campusInfo?.attributes?.metaTitleOffreAlt}${this.currentDiploma?' - '+ this.currentDiploma:''} ` :
                 `Nos offres d'alternances - ${this.campusInfo?.attributes?.name}${this.currentDiploma?' - '+ this.currentDiploma:''} `,
            meta: this.campusInfo?.attributes?.metaOffreAlt != null && this.campusInfo?.attributes?.metaOffreAlt != undefined ?
                JSON.parse(this.campusInfo?.attributes?.metaOffreAlt?.replace('\n', '')) : null
        };
    },
    data() {
        const strapiBaseUri = process.env.strapiBaseUri
        let diplomaSelectBox = '';

        if (this.$route.query?.diploma) {
            diplomaSelectBox = this.$route.query?.diploma;
        }

        return {
            strapiBaseUri, diplomaSelectBox
        }
    },
    async mounted() {


        if (this.loading == true) {
            //to try : https://admin.preprod.icfa.fr/api/SF-offre-alternances?populate[diplome][fields][0]=title,nomCourt
            this.offreAlternances = await this.$http.$get(`${process.env.strapiBaseUri}/api/${this.instance.attributes?.prefix}-offre-alternances?populate[imageOfferAlternance][fields][0]=url&populate[diplome][fields][0]=nomCourt&populate[diplome][fields][0]=couleurFormationRGB&pagination[pageSize]=100`);

            this.offreAlternances = this.offreAlternances.data;
            this.offreAlternances = this.offreAlternances.filter(offreAlternance => {
                return offreAlternance.attributes.diplome.data
            });
            this.filteredOffreAlternances = this.offreAlternances;

            this.diplomasList = []
            this.offreAlternances.map((offre) => {

                if (this.diplomasList.findIndex(diploma => diploma?.id == offre.attributes.diplome?.data?.id) == -1
                    && offre.attributes.diplome?.data?.id != undefined) {
                    this.diplomasList.push(offre.attributes.diplome.data);
                }

            });

            this.loading = false;
        }


        this.clickDiplome();
    },
    methods: {
        styleDiplomaButonGrad(offreAlternance) {
            let r, g, b;
            r = offreAlternance?.attributes?.diplome?.data?.attributes?.couleurFormationRGB?.substring(0, 3);
            g = offreAlternance?.attributes?.diplome?.data?.attributes?.couleurFormationRGB?.substring(3, 6);
            b = offreAlternance?.attributes?.diplome?.data?.attributes?.couleurFormationRGB?.substring(6, 9);

            return {
                '--text-color': '#aaaaaa',
                '--text-color1r': Number(r) + 10,
                '--text-color1g': Number(g) - 55,
                '--text-color1b': Number(b) + 30,
                '--text-color2r': Number(r) + 10,
                '--text-color2g': Number(g) + 10,
                '--text-color2b': Number(b) + 25,
                '--text-color3r': Number(r) + 40,
                '--text-color3g': Number(g) - 50,
                '--text-color3b': Number(b) - 50,
                '--text-color4r': Number(r) - 30,
                '--text-color4g': Number(g) + 30,
                '--text-color4b': Number(b) + 55
            }
        },
        clickDiplome() {
            this.filteredOffreAlternances = [];
            if (this.diplomaSelectBox != '') {
                this.offreAlternances.map(offre => {
                    if (offre.attributes.diplome.data.id == this.diplomaSelectBox) {
                        this.filteredOffreAlternances.push(offre);
                        this.currentDiploma = offre.attributes.diplome.data.attributes.acronyme;
                    }
                })
            } else {
                this.filteredOffreAlternances = this.offreAlternances;
            }

        }

    },


    async asyncData({ params, $http, store, redirect, route }) {
        // let instances = await $http.$get(`${process.env.strapiBaseUri}/api/instances`);
        // instances = instances.data;
        let instances = store.state.instances;

        const instance = instances.filter((instance) => {
            return instance.attributes.subFolderName == params.campusHP
        })[0];

        if (!instance) {
            // redirect to lost page
            redirect('/404-error/')
        }

        let offreAlternances = [];
        let filteredOffreAlternances = [];
        let diplomasList = [];
        let loading = true;

        if (process.server) {
            offreAlternances = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes?.prefix}-offre-alternances?populate=imageOfferAlternance,diplome&pagination[pageSize]=100`);

            offreAlternances = offreAlternances.data;
            offreAlternances = offreAlternances.filter(offreAlternance => {
                return offreAlternance.attributes.diplome.data
            });
            filteredOffreAlternances = offreAlternances;

            diplomasList = []
            offreAlternances.map((offre) => {

                if (diplomasList.findIndex(diploma => diploma?.id == offre.attributes.diplome?.data?.id) == -1
                    && offre.attributes.diplome?.data?.id != undefined) {
                    diplomasList.push(offre.attributes.diplome.data);
                }

            });

            loading = false;

        }



        let campusInfo = store.state.campusInfo;
        // let campusInfo = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-home-page?populate=banniereLogo`);
        // campusInfo = campusInfo.data;

        let banniereLogoUrl = process.env.strapiBaseUri + campusInfo.attributes.banniereLogo?.data?.attributes?.url;

        let campusDiplomas = await $http.$get(`${process.env.strapiBaseUri}/api/${instance.attributes.prefix}-diplomas`);
        campusDiplomas = campusDiplomas.data;
        const diplomaInfo = campusDiplomas.filter((diploma) => {
            return diploma.attributes.acronyme == params.diploma
        })[0];
        let collone1Diplomas = campusDiplomas.filter((diploma) => {
            return diploma.attributes.collone === 'Collone_1';
        })
        collone1Diplomas = collone1Diplomas.sort((d1, d2) => {
            return d1.attributes.ordre - d2.attributes.ordre
        })
        let collone2Diplomas = campusDiplomas.filter((diploma) => {
            return diploma.attributes.collone === 'Collone_2';
        })
        collone2Diplomas = collone2Diplomas.sort((d1, d2) => {
            return d1.attributes.ordre - d2.attributes.ordre
        })
        let collone3Diplomas = campusDiplomas.filter((diploma) => {
            return diploma.attributes.collone === 'Collone_3';
        })
        collone3Diplomas = collone3Diplomas.sort((d1, d2) => {
            return d1.attributes.ordre - d2.attributes.ordre
        })

        let currentDiploma;

        if(route.query.diploma){
            offreAlternances.map(offre => {
                if (offre.attributes.diplome.data.id == route.query.diploma) {
                    currentDiploma = offre.attributes.diplome.data.attributes.acronyme;
                }
            })
        }

        

        return {
            instances, instance, campusInfo, offreAlternances, filteredOffreAlternances, diplomasList, loading,
            campusDiplomas, collone1Diplomas, collone2Diplomas, collone3Diplomas, banniereLogoUrl, currentDiploma
        }
    },

}
